var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{class:`${ _vm.type == 'add' ? 'button-orange-modal' : 'bg-blue'}`,attrs:{"type":"submit"}},[_c('i',{class:_vm.icon})])
}
var staticRenderFns = []

export { render, staticRenderFns }